import script from "./AutoJobTemplateCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutoJobTemplateCard.vue?vue&type=script&setup=true&lang=ts"

import "./AutoJobTemplateCard.vue?vue&type=style&index=0&id=684aaa85&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-684aaa85"]])

export default __exports__